// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_5ba4a77"};